module.exports = __webpack_public_path__ + "img/wdht-logo.2bd896c1.svg";